import { connect } from 'react-redux';
import CategoryStyle from './category_style';
import { dyanamicMapToProps } from './index';
import { WITH_PAPER } from '../works/works';

const mapStateToProps = (state, props) => dyanamicMapToProps(WITH_PAPER)(state, props);

export default connect(mapStateToProps, {})(CategoryStyle);
